import { $$tracker } from '@src/tracker';

const trackerMap = {
  youtube_link: $$tracker.clickMainNaviBarYoutube,
  twitter_link: $$tracker.clickMainNaviBarTwitter,
  discord_link: $$tracker.clickMainNaviBarDiscord
  // steam_link: $$tracker.clickDlcmsmkSteam
};

function goToShare(type) {
  // trackerMap[type]?.();
  let url = window.mechabreakConfig[type];
  if (url) {
    window.open(window.mechabreakConfig[type]);
  }
}

export default goToShare;
